<template>
	<div class="helpcenter_chidrenbox">
		<div class="helpcenter_item1_title">玩法介绍</div>
		<div class="playIntro_box">
			<el-tabs v-model="activeName">
				<el-tab-pane label="时时彩" name="first">
					<table
						cellspacing="0"
						cellpadding="0"
						border="0"
						width="100%"
						class="table table-striped table-hover table-bordered"
					>
						<thead>
							<tr>
								<th align="center" colspan="4">
									<h2>重庆时时彩、江西时时彩 、新疆时时彩玩法介绍</h2>
								</th>
							</tr>
							<tr>
								<th width="15%">玩法组</th>
								<th width="15%">玩法</th>
								<th width="30%">玩法说明</th>
								<th width="30%">中奖举例</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td rowspan="3">五星直选</td>
								<td>直选（复式）</td>
								<td>
									从万位、千位、百位、十位、个位中选择一个5位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖。
								</td>
								<td>如：投注方案：23456；开奖号码：23456，即中五星直选。</td>
							</tr>
							<tr>
								<td>直选（单式）</td>
								<td>
									手动输入一个5位数号码组成一注，所选号码的万位、千位、百位、十位、个位与开奖号码相同，且顺序一致，即为中奖。
								</td>
								<td>如：投注方案：23456；开奖号码：23456，即中五星直选。</td>
							</tr>
							<tr>
								<td>组合</td>
								<td>
									从万位、千位、百位、十位、个位中至少各选一个号码组成1-5星的组合，共五注，所选号码的个位与开奖号码全部相同，则中1个5等奖；所选号码的个位、十位与开奖号码相同，则中1个5等奖以及1个4等奖，依此类推，最高可中5个奖。
								</td>
								<td>
									如：五星组合示例，如购买：4+5+6+7+8，该票共10元，由以下5注：45678(五星)、5678(四星)、678(三星)、78(二星)、8(一星)构成。开奖号码：45678，即可中五星、四星、三星、二星、一星各1注。
								</td>
							</tr>
							<tr>
								<td rowspan="6">五星组选</td>
								<td>五星组选120</td>
								<td>
									从0-9中任意选择5个号码组成一注，所选号码与开奖号码的万位、千位、百位、十位、个位相同，顺序不限，即为中奖。
								</td>
								<td>
									如：投注方案：02568，开奖号码的5个数字必须包含02568（例如：08526），顺序不限，即可中五星组选120。
								</td>
							</tr>
							<tr>
								<td>五星组选60</td>
								<td>
									选择1个二重号码和3个单号号码组成一注，所选的单号号码与开奖号码相同，且所选二重号码在开奖号码中出现了2次，即为中奖。
								</td>
								<td>
									如：投注方案：二重号：8；单号：025，开奖号码的5个数字必须包含单号025，以及对子号8（例如02858），顺序不限，即可中五星组选60。
								</td>
							</tr>
							<tr>
								<td>五星组选30</td>
								<td>
									选择2个二重号和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选的2个二重号码分别在开奖号码中出现了2次，即为中奖。
								</td>
								<td>
									如：投注方案：二重号：2、8；单号：0，开奖号码的5个数字必须包含单号0，以及对子号2和8（例如28082），顺序不限，即可中五星组选30。
								</td>
							</tr>
							<tr>
								<td>五星组选20</td>
								<td>
									选择1个三重号码和2个单号号码组成一注，所选的单号号码与开奖号码相同，且所选三重号码在开奖号码中出现了3次，即为中奖。
								</td>
								<td>
									如：投注方案：三重号：8；单号：0、2，开奖号码的5个数字必须包含单号0和2，以及三重号8（例如80828），顺序不限，即可中五星组选20。
								</td>
							</tr>
							<tr>
								<td>五星组选10</td>
								<td>
									选择1个三重号码和1个二重号码，所选三重号码在开奖号码中出现3次，并且所选二重号码在开奖号码中出现了2次，即为中奖。
								</td>
								<td>
									如：投注方案：三重号：8；二重号：2，开奖号码的5个数字必须包含三重号8，以及对子号2（例如28828），顺序不限，即可中五星组选10。
								</td>
							</tr>
							<tr>
								<td>五星组选5</td>
								<td>
									选择1个四重号码和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选四重号码在开奖号码中出现了4次，即为中奖。
								</td>
								<td>
									如：投注方案：四重号：8；单号：2，开奖号码的5个数字必须包含四重号8，以及单号2（例如88828），顺序不限，即可中五星组选5。
								</td>
							</tr>
							<tr>
								<td rowspan="2">四星直选</td>
								<td>直选 （复式）</td>
								<td>
									从千位、百位、十位、个位中选择一个4位数号码组成一注，所选号码与开奖号码相同，且顺序一致，即为中奖。
								</td>
								<td>如：投注方案：3456；开奖号码：*3456，即中四星直选。</td>
							</tr>
							<tr>
								<td>直选 （单式）</td>
								<td>
									手动输入一个4位数号码组成一注，所选号码的千位、百位、十位、个位与开奖号码相同，且顺序一致，即为中奖。
								</td>
								<td>如：投注方案：3456；开奖号码：*3456，即中四星直选。</td>
							</tr>
							<tr>
								<td rowspan="1">四星组合</td>
								<td>组合</td>
								<td>
									从千位、百位、十位、个位中至少各选一个号码组成1-4星的组合，共四注，所选号码的个位与开奖号码相同，则中1个4等奖；所选号码的个位、十位与开奖号码相同，则中1个4等奖以及1个3等奖，依此类推，最高可中4个奖。
								</td>
								<td>
									如：四星组合示例，如购买：5+6+7+8，该票共8元，由以下4注：5678(四星)、678(三星)、78(二星)、8(一星)构成。开奖号码：*5678，即可中四星、三星、二星、一星各1注。
								</td>
							</tr>
							<tr>
								<td rowspan="4">四星组选</td>
								<td>四星组选24</td>
								<td>
									从0-9中任意选择4个号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且顺序不限，即为中奖。
								</td>
								<td>如：投注方案：0568，开奖号码的后4个数字必须包含0568（例如0856），顺序不限，即可中四星组选24。</td>
							</tr>
							<tr>
								<td>四星组选12</td>
								<td>
									从千位、百位、十位、个位中，选择1个二重号码和2个单号号码组成一注，所选单号号码与开奖号码相同，且所选二重号码在开奖号码中出现了2次，即为中奖。
								</td>
								<td>
									如：投注方案：二重号：8；单号：0、6，开奖号码的后4个数字必须包含单号0、6和对子号8（例如0868），顺序不限，即可中四星组选12。
								</td>
							</tr>
							<tr>
								<td>四星组选6</td>
								<td>
									从千位、百位、十位、个位中，选择2个二重号码组成一注，所选的2个二重号码在开奖号码中分别出现了2次，即为中奖。
								</td>
								<td>
									如：投注方案：二重号：2、8，开奖号码的后4个数字必须包含两个对子号2和8（例如2882），顺序不限，即可中四星组选6。
								</td>
							</tr>
							<tr>
								<td>四星组选4</td>
								<td>
									从千位、百位、十位、个位中，选择1个三重号码和1个单号号码组成一注，所选单号号码与开奖号码相同，且所选三重号码在开奖号码中出现了3次，即为中奖。
								</td>
								<td>
									如：投注方案：三重号：8；单号：2，开奖号码的后4个数字必须包含三重号8，以及单号2（比如8828）顺序不限，即可中四星组选4。
								</td>
							</tr>
							<tr>
								<td rowspan="3">前三直选</td>
								<td>直选复式</td>
								<td>
									从万位、千位、百位中选择一个3位数号码组成一注，所选号码与开奖号码前3位相同，且顺序一致，即为中奖。
								</td>
								<td>如：万位选择1，千位选择2，百位选择3，开奖号码为是123**，即为中奖。</td>
							</tr>
							<tr>
								<td>直选单式</td>
								<td>手动输入一个3位数号码组成一注，所选号码与开奖号码的万位、千位、百位相同，且顺序一致，即为中奖。</td>
								<td>如：手动输入123，开奖号码为是123**，即为中奖。</td>
							</tr>
							<tr>
								<td>直选和值</td>
								<td>所选数值等于开奖号码万位、千位、百位三个数字相加之和，即为中奖。</td>
								<td>如：选择6，开奖号码为123**、141**、114**、006**、060**等任意一个和值为6的结果，即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="3">后三直选</td>
								<td>直选复式</td>
								<td>
									从百位、十位、个位中选择一个3位数号码组成一注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖。
								</td>
								<td>如：百位选择1，十位选择2，个位选择3，开奖号码为是**123，即为中奖。</td>
							</tr>
							<tr>
								<td>直选单式</td>
								<td>手动输入一个3位数号码组成一注，所选号码与开奖号码的百位、十位、个位相同，且顺序一致，即为中奖。</td>
								<td>如：手动输入123，开奖号码为是**123，即为中奖。</td>
							</tr>
							<tr>
								<td>直选和值</td>
								<td>所选数值等于开奖号码的百位、十位、个位三个数字相加之和，即为中奖。</td>
								<td>如：选择6，开奖号码为**123、**141、**114、**006、**060等任意一个和值为6的结果，即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="4">前三组选</td>
								<td>组三</td>
								<td>
									从0-9中任意选择2个号码组成两注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖。
								</td>
								<td>
									如：选择12（展开为122**，212**，221** 和 112**、121**、211**），开奖号码为212** 或 121**，即为中奖。
								</td>
							</tr>
							<tr>
								<td>组六</td>
								<td>从0-9中任意选择3个号码组成一注，所选号码与开奖号码的万位、千位、百位相同，顺序不限，即为中奖。</td>
								<td>如：选择123（展开为123**，132**，231**，213**，312**，321**），开奖号码为321**，即为中奖。</td>
							</tr>
							<tr>
								<td>组选和值</td>
								<td>所选数值等于开奖号码万位、千位、百位三个数字相加之和，即为中奖。</td>
								<td>如：选择6，开奖号码为114**中组三奖，开奖号码为015**中组六奖。</td>
							</tr>
							<tr>
								<td>混合组选</td>
								<td>键盘手动输入购买号码，3个数字为一注，开奖号码的万位、千位、百位符合前三的组三或组六均为中奖。</td>
								<td>如：手动输入123、455，开奖号码为321**即中组六奖，开奖号码为545**即中组三奖。</td>
							</tr>
							<tr>
								<td rowspan="4">后三组选</td>
								<td>组三</td>
								<td>
									从0-9中任意选择2个号码组成两注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖。
								</td>
								<td>
									如：选择12（展开为**122，**212，**221 和 **112、**121、**211），开奖号码为**212 或 **121，即为中奖。
								</td>
							</tr>
							<tr>
								<td>组六</td>
								<td>从0-9中任意选择3个号码组成一注，所选号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖。</td>
								<td>如：选择123（展开为**123，**132，**231，**213，**312，**321），开奖号码为**321，即为中奖。</td>
							</tr>
							<tr>
								<td>组选和值</td>
								<td>所选数值等于开奖号码百位、十位、个位三个数字相加之和，即为中奖。</td>
								<td>如：选择6，开奖号码为**114中组三奖，开奖号码为**015中组六奖。</td>
							</tr>
							<tr>
								<td>混合组选</td>
								<td>键盘手动输入购买号码，3个数字为一注，开奖号码的百位、十位、个位符合前三的组三或组六均为中奖。</td>
								<td>如：手动输入123、455，开奖号码为**321即中组六奖，开奖号码为**545即中组三奖。</td>
							</tr>
							<tr>
								<td rowspan="2">后三不定位</td>
								<td>一码不定位</td>
								<td>从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖。</td>
								<td>如：选择一码不定位4，开出**4**、***4*、****4即为中奖。</td>
							</tr>
							<tr>
								<td>二码不定位</td>
								<td>
									从0-9中选择2个号码，每注由2个不同的号码组成，开奖号码的百位、十位、个位中同时包含所选的2个号码，即为中奖。
								</td>
								<td>如：选择二码不定位4、5，开奖号码为***45、**5*4、***54即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="10">二星</td>
								<td>前二直选复式</td>
								<td>从万位和千位上至少各选1个号码，所选号码与开奖号码的万位、千位相同，且顺序一致，即为中奖。</td>
								<td>如：万位选择3，千位选择4，开出34***即为中奖。</td>
							</tr>
							<tr height="49" style="-webkit-user-drag: none; height: 36.75pt">
								<td>前二直选单式</td>
								<td>手动输入一个2位数号码组成一注，所选号码与开奖号码的万位、千位相同，且顺序一致，即为中奖。</td>
								<td>如：手动输入12，开奖号码为是12***，即为中奖。</td>
							</tr>
							<tr>
								<td>前二组选复式</td>
								<td>从0-9中选2个号码组成一注，所择号码与开奖号码的万位、千位相同，顺序不限，不含对子号，即为中奖。</td>
								<td>如：选择7、8，开奖号码78***或87***，即为中奖。</td>
							</tr>
							<tr>
								<td>前二组选单式</td>
								<td>
									手动输入购买号码，2个数字为一注，所选号码与开奖号码的万位、千位相同，顺序不限，不含对子号，即为中奖。
								</td>
								<td>如：手动输入12，开奖号码为是21***或12***，即为中奖。</td>
							</tr>
							<tr>
								<td>前二组选和值</td>
								<td>所选数值等于开奖号码的万位、千位两个数字相加之和（不含对子号）即为中奖。</td>
								<td>如：和值8；，开奖号码前二位08或者80（顺序不限，不含对子号），即为中奖。</td>
							</tr>
							<tr>
								<td>后二直选复式</td>
								<td>从十位和个位上至少各选1个号码，所选号码与开奖号码的十位、个位相同，且顺序一致，即为中奖。</td>
								<td>如：十位选择3，个位现在4，开奖号码为***34，即为中奖。</td>
							</tr>
							<tr>
								<td>后二直选单式</td>
								<td>手动输入一个2位数号码组成一注，所选号码与开奖号码的十位、个位相同，且顺序一致，即为中奖。</td>
								<td>如：手动输入12，开奖号码为是***12，即为中奖。</td>
							</tr>
							<tr>
								<td>后二组选复式</td>
								<td>从0-9中选2个号码组成一注，所选号码与开奖号码的十位、个位相同，顺序不限，不含对子号，即为中奖。</td>
								<td>如：选择7、8，开奖号码***78或***87即为中奖。</td>
							</tr>
							<tr>
								<td>后二组选单式</td>
								<td>
									手动输入购买号码，2个数字为一注，所选号码与开奖号码的十位、个位相同，顺序不限，不含对子号，即为中奖。
								</td>
								<td>如：手动输入12，开奖号码为是***21或者***12，即为中奖。</td>
							</tr>
							<tr>
								<td>后二组选和值</td>
								<td>所选数值等于开奖号码的十位、个位两个数字相加之和（不含对子号）即为中奖。</td>
								<td>如：和值8；，开奖号码后二位08或者80（顺序不限，不含对子号），即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="5">定位胆</td>
								<td>万位</td>
								<td rowspan="5">
									从万位、千位、百位、十位、个位任意1个位置或多个位置上选择1个号码，所选号码与相同位置上的开奖号码一致，即为中奖。
								</td>
								<td>如：定万位为1，开奖号码为1****即为中奖。</td>
							</tr>
							<tr>
								<td>千位</td>
								<td>如：定千位为2，开奖号码为*2***即为中奖。</td>
							</tr>
							<tr>
								<td>百位</td>
								<td>如：定百位为3，开奖号码为**3**即为中奖。</td>
							</tr>
							<tr>
								<td>十位</td>
								<td>如：定十位为4，开奖号码为***4*即为中奖。</td>
							</tr>
							<tr>
								<td>个位</td>
								<td>如：定个位为5，开奖号码为****5即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="2">大小单双</td>
								<td>前二</td>
								<td>
									对万位和千位的“大（56789）小（01234）、单（13579）双（02468）”形态进行购买，所选号码的位置、形态与开奖号码的位置、形态相同，即为中奖。
								</td>
								<td>如：万位选择大，千位选择单，开出63***即为中奖。</td>
							</tr>
							<tr>
								<td>后二</td>
								<td>
									对十位和个位的“大（56789）小（01234）、单（13579）双（02468）”形态进行购买，所选号码的位置、形态与开奖号码的位置、形态相同，即为中奖。
								</td>
								<td>如：十位选择小，个位选择双，开出***12即为中奖</td>
							</tr>
							<tr>
								<td rowspan="4">趣味</td>
								<td>一帆风顺</td>
								<td>
									从0-9中任意选择1个号码组成一注，
									<wbr />
									只要开奖号码的万位, 千位,百位, 十位, 个位中包含所选号码,
									<wbr />
									即为中奖。
								</td>
								<td>
									如：投注方案：8，至少出现1个8，
									<wbr />
									即中一帆风顺。
								</td>
							</tr>
							<tr>
								<td>好事成双</td>
								<td>
									从0-9中任意选择1个号码组成一注，
									<wbr />
									只要所选号码在开奖号码的万位, 千位, 百位, 十位, 个位中出现2次相同，即为中奖。
								</td>
								<td>
									如：投注方案：8；至少出现2个8，
									<wbr />
									即中好事成双。
								</td>
							</tr>
							<tr>
								<td>三星报喜</td>
								<td>
									从0-9中任意选择1个号码组成一注，
									<wbr />
									只要所选号码在开奖号码的万位, 千位, 百位, 十位, 个位中出现3次, 即为中奖。
								</td>
								<td>如：投注方案：8：开奖号码，三重号，即中三星报喜。</td>
							</tr>
							<tr>
								<td>四季发财</td>
								<td>
									从从0-9中任意选择1个号码组成一注，
									<wbr />
									只要所选号码在开奖号码的万位, 千位, 百位, 十位, 个位中出现4次, 即为中奖。
								</td>
								<td>
									如：投注方案：8；至少出现4个8，
									<wbr />
									即为四季发财。
								</td>
							</tr>
							<tr></tr>
						</tbody>
					</table>
				</el-tab-pane>
				<el-tab-pane label="福彩3D" name="second">
					<table
						border="0"
						cellspacing="0"
						cellpadding="0"
						width="100%"
						class="table table-striped table-hover table-bordered"
					>
						<thead>
							<tr>
								<th colspan="4" align="center">
									<h2>福彩3D玩法介绍</h2>
								</th>
							</tr>
							<tr>
								<th width="15%">玩法组</th>
								<th width="15%">玩法</th>
								<th width="30%">玩法说明</th>
								<th width="30%">中奖举例</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td rowspan="3">直选</td>
								<td>直选复式</td>
								<td>从百位、十位、个位中选择一个3位数号码组成一注，所选号码与开奖号码相同，且顺序一致，即为中奖。</td>
								<td>如：百位选择1，十位选择2，个位选择3，开奖号码为是123，即为中奖。</td>
							</tr>
							<tr>
								<td>直选单式</td>
								<td>手动输入一个3位数号码组成一注，所选号码与开奖号码相同，且顺序一致，即为中奖。</td>
								<td>如：手动输入123，开奖号码为是123，即为中奖。</td>
							</tr>
							<tr>
								<td>直选和值</td>
								<td>所选数值等于开奖号码的三个数字相加之和，即为中奖。</td>
								<td>如：选择6，开奖号码为123、141、114、006、060等任意一个和值为6的结果，即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="4">组选</td>
								<td>组三</td>
								<td>从0-9中任意选择2个数字组成两注，所选号码与开奖号码相同，顺序不限，即为中奖。</td>
								<td>如：选择12（展开为122，212，221 和 112、121、211），开奖号码为212 或 121，即为中奖。</td>
							</tr>
							<tr>
								<td>组六</td>
								<td>从0-9中任意选择3个号码组成一注，所选号码与开奖号码相同，顺序不限，即为中奖。</td>
								<td>如：选择123（展开为123，132，231，213，312，321），开奖号码为321，即为中奖。</td>
							</tr>
							<tr>
								<td>组选和值</td>
								<td>所选数值等于开奖号码的三个数字相加之和，即为中奖。</td>
								<td>如：选择6，开奖号码为114中组三奖，开奖号码为015中组六奖。</td>
							</tr>
							<tr>
								<td>混合组选</td>
								<td>手动输入购买号码，3个数字为一注，开奖号码符合组三或组六均为中奖。</td>
								<td>如：选择123、455，开奖号码为321即中组六奖，开奖号码为545即中组三奖。</td>
							</tr>
							<tr>
								<td rowspan="2">不定位</td>
								<td>一码不定位</td>
								<td>从0-9中选择1个号码，每注由1个号码组成，只要开奖结果中包含所选号码，即为中奖。</td>
								<td>如：选择一码不定位4，开出4**、*4*、**4即为中奖。</td>
							</tr>
							<tr>
								<td>二码不定位</td>
								<td>
									从0-9中选择2个号码，每注由2个不同的号码组成，开奖号码的百位、十位、个位中同时包含所选的2个号码，即为中奖。
								</td>
								<td>如：选择二码不定位4、5，开奖号码为*45、5*4、*54即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="8">二星</td>
								<td>前二直选复式</td>
								<td>从百位和十位上至少各选1个号码，所选号码与开奖号码百位、十位相同，且顺序一致，即为中奖。</td>
								<td>如：百位选择3，十位选择4，开奖号码为34*，即为中奖。</td>
							</tr>
							<tr>
								<td>前二直选单式</td>
								<td>手动输入一个2位数号码组成一注，所选号码与开奖号码的百位、十位相同，且顺序一致，即为中奖。</td>
								<td>如：手动输入12，开奖号码为是12*，即为中奖。</td>
							</tr>
							<tr>
								<td>前二组选复式</td>
								<td>从0-9中选2个号码组成一注，所选号码与开奖号码的百位、十位相同，顺序不限，即为中奖。</td>
								<td>如：百位选择7，十位选择8，开奖号码78*或87*，即为中奖。</td>
							</tr>
							<tr>
								<td>前二组选单式</td>
								<td>手动输入购买号码，2个数字为一注，所选号码与开奖号码的百位、十位相同，顺序不限，即为中奖。</td>
								<td>如：手动输入12，开奖号码为是21*或12*，即为中奖。</td>
							</tr>
							<tr>
								<td>后二直选复式</td>
								<td>从十位和个位上至少各选1个号码，所选号码与开奖号码的十位、个位相同，且顺序一致，即为中奖。</td>
								<td>如：十位选择3，个位选择4，开奖号码为*34，即为中奖。</td>
							</tr>
							<tr>
								<td>后二直选单式</td>
								<td>手动输入一个2位数号码组成一注，所选号码与开奖号码的十位、个位相同，且顺序一致，即为中奖。</td>
								<td>如：手动输入12，开奖号码为是*12，即为中奖。</td>
							</tr>
							<tr>
								<td>后二组选复式</td>
								<td>从0-9中选2个号码组成一注，所选号码与开奖号码的十位、个位相同，顺序不限，即为中奖。</td>
								<td>如：选择7、8，开奖号码*78或*87，即为中奖。</td>
							</tr>
							<tr>
								<td>后二组选单式</td>
								<td>手动输入购买号码，2个数字为一注，所选号码与开奖号码的十位、个位相同，顺序不限，即为中奖。</td>
								<td>如：手动输入12，开奖号码为是*21或者*12，即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="3">定位胆</td>
								<td>百位</td>
								<td rowspan="3">
									从百位、十位、个位任意1个位置或多个位置上选择1个号码，所选号码与相同位置上的开奖号码一致，即为中奖。
								</td>
								<td>如：定百位为3，开奖号码为3**，即为中奖。</td>
							</tr>
							<tr>
								<td>十位</td>
								<td>如：定十位为4，开奖号码为*4*，即为中奖。</td>
							</tr>
							<tr>
								<td>个位</td>
								<td>如：定个位为5，开奖号码为**5，即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="2">大小单双</td>
								<td>前二</td>
								<td>
									对百位和十位的“大（56789）小（01234）、单（13579）双（02468）”形态进行购买，所选号码的位置、形态与开奖号码的位置、形态相同，即为中奖。
								</td>
								<td>如：百位选择大，十位选择单，开出63*即为中奖。</td>
							</tr>
							<tr>
								<td>后二</td>
								<td>
									对十位和个位的“大（56789）小（01234）、单（13579）双（02468）”形态进行购买，所选号码的位置、形态与开奖号码的位置、形态相同，即为中奖。
								</td>
								<td>如：十位选择小，个位选择双，开出*12即为中奖</td>
							</tr>
						</tbody>
					</table>
				</el-tab-pane>
				<el-tab-pane label="排列三" name="third">
					<table
						border="0"
						cellspacing="0"
						cellpadding="0"
						width="100%"
						class="table table-striped table-hover table-bordered"
					>
						<thead>
							<tr>
								<th colspan="4" align="center">
									<h2>排列三玩法介绍</h2>
								</th>
							</tr>
							<tr>
								<th width="15%">玩法组</th>
								<th width="15%">玩法</th>
								<th width="30%">玩法说明</th>
								<th width="30%">中奖举例</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td rowspan="3">排三直选</td>
								<td>直选复式</td>
								<td>
									从万位、千位、百位中选择一个3位数号码组成一注，所选号码与开奖号码前3位相同，且顺序一致，即为中奖。
								</td>
								<td>如：万位选择1，千位选择2，百位选择3，开奖号码为是123**，即为中奖。</td>
							</tr>
							<tr>
								<td>直选单式</td>
								<td>手动输入一个3位数号码组成一注，所选号码与开奖号码的万位、千位、百位相同，且顺序一致，即为中奖。</td>
								<td>如：手动输入123，开奖号码为是123**，即为中奖。</td>
							</tr>
							<tr>
								<td>直选和值</td>
								<td>所选数值等于开奖号码万位、千位、百位三个数字相加之和，即为中奖。</td>
								<td>如：选择6，开奖号码为123**、141**、114**、006**、060**等任意一个和值为6的结果，即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="4">排三组选</td>
								<td>组三</td>
								<td>
									从0-9中任意选择2个号码组成两注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖。
								</td>
								<td>
									如：选择12（展开为122**，212**，221** 和 112**、121**、211**），开奖号码为212** 或 121**，即为中奖。
								</td>
							</tr>
							<tr>
								<td>组六</td>
								<td>从0-9中任意选择3个号码组成一注，所选号码与开奖号码的万位、千位、百位相同，顺序不限，即为中奖。</td>
								<td>如：选择123（展开为123**，132**，231**，213**，312**，321**），开奖号码为321**，即为中奖。</td>
							</tr>
							<tr>
								<td>组选和值</td>
								<td>所选数值等于开奖号码万位、千位、百位三个数字相加之和，即为中奖。</td>
								<td>如：选择6，开奖号码为114**中组三奖，开奖号码为015**中组六奖。</td>
							</tr>
							<tr>
								<td>混合组选</td>
								<td>键盘手动输入购买号码，3个数字为一注，开奖号码的万位、千位、百位符合前三的组三或组六均为中奖。</td>
								<td>如：手动输入123、455，开奖号码为321**即中组六奖，开奖号码为545**即中组三奖。</td>
							</tr>
							<tr>
								<td rowspan="2">排三不定位</td>
								<td>一码不定位</td>
								<td>从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖。</td>
								<td>如：选择一码不定位4，开出4****、*4***、**4**即为中奖。</td>
							</tr>
							<tr>
								<td>二码不定位</td>
								<td>
									从0-9中选择2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位中同时包含所选的2个号码，即为中奖。
								</td>
								<td>如：选择二码不定位4、5，开奖号码为*45**、*54**、4*5**、5*4**、45***、54***、即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="8">排五二星</td>
								<td>前二直选复式</td>
								<td>从万位和千位上至少各选1个号码，所选号码与开奖号码的万位、千位相同，且顺序一致，即为中奖。</td>
								<td>如：万位选择3，千位选择4，开出34***即为中奖。</td>
							</tr>
							<tr>
								<td>前二直选单式</td>
								<td>手动输入一个2位数号码组成一注，所选号码与开奖号码的万位、千位相同，且顺序一致，即为中奖。</td>
								<td>如：手动输入12，开奖号码为是12***，即为中奖。</td>
							</tr>
							<tr>
								<td>前二组选复式</td>
								<td>从0-9中选2个号码组成一注，所择号码与开奖号码的万位、千位相同，顺序不限，即为中奖。</td>
								<td>如：选择7、8，开奖号码78***或87***，即为中奖。</td>
							</tr>
							<tr>
								<td>前二组选单式</td>
								<td>手动输入购买号码，2个数字为一注，所选号码与开奖号码的万位、千位相同，顺序不限，即为中奖。</td>
								<td>如：手动输入12，开奖号码为是21***或12***，即为中奖。</td>
							</tr>
							<tr>
								<td>后二直选复式</td>
								<td>从十位和个位上至少各选1个号码，所选号码与开奖号码的十位、个位相同，且顺序一致，即为中奖。</td>
								<td>如：十位选择3，个位现在4，开奖号码为***34，即为中奖。</td>
							</tr>
							<tr>
								<td>后二直选单式</td>
								<td>手动输入一个2位数号码组成一注，所选号码与开奖号码的十位、个位相同，且顺序一致，即为中奖。</td>
								<td>如：手动输入12，开奖号码为是***12，即为中奖。</td>
							</tr>
							<tr>
								<td>后二组选复式</td>
								<td>从0-9中选2个号码组成一注，所选号码与开奖号码的十位、个位相同，顺序不限，即为中奖。</td>
								<td>如：选择7、8，开奖号码***78或***87即为中奖。</td>
							</tr>
							<tr>
								<td>后二组选单式</td>
								<td>手动输入购买号码，2个数字为一注，所选号码与开奖号码的十位、个位相同，顺序不限，即为中奖。</td>
								<td>如：手动输入12，开奖号码为是***21或者***12，即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="5">排五定位胆</td>
								<td>万位</td>
								<td rowspan="5">
									从万位、千位、百位、十位、个位任意1个位置或多个位置上选择1个号码，所选号码与相同位置上的开奖号码一致，即为中奖。
								</td>
								<td>如：定万位为1，开奖号码为1****即为中奖。</td>
							</tr>
							<tr>
								<td>千位</td>
								<td>如：定千位为2，开奖号码为*2***即为中奖。</td>
							</tr>
							<tr>
								<td>百位</td>
								<td>如：定百位为3，开奖号码为**3**即为中奖。</td>
							</tr>
							<tr>
								<td>十位</td>
								<td>如：定十位为4，开奖号码为***4*即为中奖。</td>
							</tr>
							<tr>
								<td>个位</td>
								<td>如：定个位为5，开奖号码为****5即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="2">排五大小单双</td>
								<td>前二</td>
								<td>
									对万位和千位的“大（56789）小（01234）、单（13579）双（02468）”形态进行购买，所选号码的位置、形态与开奖号码的位置、形态相同，即为中奖。
								</td>
								<td>如：万位选择大，千位选择单，开出63***即为中奖。</td>
							</tr>
							<tr>
								<td>后二</td>
								<td>
									对十位和个位的“大（56789）小（01234）、单（13579）双（02468）”形态进行购买，所选号码的位置、形态与开奖号码的位置、形态相同，即为中奖。
								</td>
								<td>如：十位选择小，个位选择双，开出***12即为中奖</td>
							</tr>
						</tbody>
					</table>
				</el-tab-pane>
				<el-tab-pane label="十一选五" name="fourth">
					<table
						border="0"
						cellspacing="0"
						cellpadding="0"
						width="100%"
						class="table table-striped table-hover table-bordered"
					>
						<thead>
							<tr>
								<th colspan="4" align="center">
									<h2>十一选五玩法介绍</h2>
								</th>
							</tr>
							<tr>
								<th width="15%">玩法组</th>
								<th width="15%">玩法</th>
								<th width="30%">玩法说明</th>
								<th width="30%">中奖举例</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td rowspan="4">三码</td>
								<td>前三直选复式</td>
								<td>
									从01-11共11个号码中选择3个不重复的号码组成一注，所选号码与当期顺序摇出的5个号码中的前3个号码相同，且顺序一致，即为中奖。
								</td>
								<td>如：第一位选择01，第二位选择02，第三位选择03，开奖号码顺序为01，02，03 * *，即为中奖。</td>
							</tr>
							<tr>
								<td>前三直选单式</td>
								<td>
									手动输入3个号码组成一注，所输入的号码与当期顺序摇出的5个号码中的前3个号码相同，且顺序一致，即为中奖。
								</td>
								<td>如：手动输入01 02 03，开奖号码为是01 02 03 * *，即为中奖。</td>
							</tr>
							<tr>
								<td>前三组选复式</td>
								<td>
									从01-11中共11个号码中选择3个号码，所选号码与当期顺序摇出的5个号码中的前3个号码相同，顺序不限，即为中奖。
								</td>
								<td>
									&nbsp; 如：选择01 02 03（展开为01 02 03 * *，01 03 02 * *，02 01 03 * *，02 03 01 * *，03 01 02 *
									*，03 02 01 * *），开奖号码为03 01 02，即为中奖。
								</td>
							</tr>
							<tr>
								<td>前三组选单式</td>
								<td>
									手动输入3个号码组成一注，所输入的号码与当期顺序摇出的5个号码中的前3个号码相同，顺序不限，即为中奖。
								</td>
								<td>
									如：手动输入01 02 03（展开为01 02 03 * *，01 03 02 * * , 02 01 03 * *，02 03 01 * *，03 01 02 * *，03
									02 01 * *），开奖号码为01 03 02 * *，即为中奖。
								</td>
							</tr>
							<tr>
								<td rowspan="4">二码</td>
								<td>前二直选复式</td>
								<td>
									从01-11共11个号码中选择2个不重复的号码组成一注，所选号码与当期顺序摇出的5个号码中的前2个号码相同，且顺序一致，即中奖。
								</td>
								<td>如：第一位选择01，第二位选择02，开奖号码 01 02 * * *，即为中奖。</td>
							</tr>
							<tr>
								<td>前二直选单式</td>
								<td>
									手动输入2个号码组成一注，所输入的号码与当期顺序摇出的5个号码中的前2个号码相同，且顺序一致，即为中奖。
								</td>
								<td>如：手动输入 01 02，开奖号码为01 02 * * *，即为中奖。</td>
							</tr>
							<tr>
								<td>前二组选复式</td>
								<td>
									从01-11中共11个号码中选择2个号码，所选号码与当期顺序摇出的5个号码中的前2个号码相同，顺序不限，即为中奖。
								</td>
								<td>
									如：选择01 02（展开为01 02 * * *，02 01 * * *），开奖号码为02 01 * * * 或 01 02 * * *，即为中奖。
								</td>
							</tr>
							<tr>
								<td>前二组选单式</td>
								<td>
									手动输入2个号码组成一注，所输入的号码与当期顺序摇出的5个号码中的前2个号码相同，顺序不限，即为中奖。
								</td>
								<td>
									如：手动输入01 02（展开为01 02 * * *，02 01 * * *），开奖号码为02 01 *** 或 01 02 ***，即为中奖。
								</td>
							</tr>
							<tr>
								<td>不定位</td>
								<td>前三不定位</td>
								<td>
									从01-11中共11个号码中选择1个号码，每注由1个号码组成，只要当期顺序摇出的第一位、第二位、第三位开奖号码中包含所选号码，即为中奖。
								</td>
								<td>如：选择01，开奖号码为01 * * * *，* 01 * * *，* * 01 * *，即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="3">定位胆</td>
								<td>第一位</td>
								<td rowspan="3">
									从第一位，第二位，第三位任意1个位置或多个位置上选择1个号码，所选号码与相同位置上的开奖号码一致，即为中奖。
								</td>
								<td>如：第一位选择01，开奖号码为01 * * * *，即为中奖。</td>
							</tr>
							<tr>
								<td>第二位</td>
								<td>如：第二位选择05，开奖号码为 * 05* * *，即为中奖。</td>
							</tr>
							<tr>
								<td>第三位</td>
								<td>如：第三位选择07，开奖号码为 * * 07 * *，即为中奖。</td>
							</tr>
							<tr>
								<td rowspan="2">趣味性</td>
								<td>定单双</td>
								<td>从5种单双个数组合中选择1种组合，当期开奖号码的单双个数与所选单双组合一致，即为中奖。</td>
								<td>如：选择5单0双，开奖号码01，03，05，07，09五个单数，即为中奖。</td>
							</tr>
							<tr>
								<td>猜中位</td>
								<td>从3-9中选择1个号码进行购买，所选号码与5个开奖号码按照大小顺序排列后的第3个号码相同，即为中奖。</td>
								<td>
									如：选择8，开奖号码为11，04，09，05，08，按开奖号码的数字大小排列为04，05，08，09，11，中间数08，即为中奖。
								</td>
							</tr>
							<tr>
								<td rowspan="8">任选</td>
								<td>任选一中一</td>
								<td>从01-11共11个号码中选择1个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
								<td>如：选择05，开奖号码为08 04 11 05 03，即为中奖</td>
							</tr>
							<tr>
								<td>任选二中二</td>
								<td>从01-11共11个号码中选择2个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
								<td>如：选择05 04，开奖号码为08 04 11 05 03，即为中奖。</td>
							</tr>
							<tr>
								<td>任选三中三</td>
								<td>从01-11共11个号码中选择3个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
								<td>如：选择05 04 11，开奖号码为08 04 11 05 03，即为中奖。</td>
							</tr>
							<tr>
								<td>任选四中四</td>
								<td>从01-11共11个号码中选择4个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
								<td>如：选择05 04 08 03，开奖号码为08 04 11 05 03，即为中奖。</td>
							</tr>
							<tr>
								<td>任选五中五</td>
								<td>从01-11共11个号码中选择5个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
								<td>如：选择05 04 11 03 08，开奖号码为08 04 11 05 03，即为中奖。</td>
							</tr>
							<tr>
								<td>任选六中五</td>
								<td>从01-11共11个号码中选择6个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
								<td>如：选择05 10 04 11 03 08，开奖号码为08 04 11 05 03，即为中奖。</td>
							</tr>
							<tr>
								<td>任选七中五</td>
								<td>从01-11共11个号码中选择7个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
								<td>如：选择05 04 10 11 03 08 09，开奖号码为08 04 11 05 03，即为中奖。</td>
							</tr>
							<tr>
								<td>任选八中五</td>
								<td>从01-11共11个号码中选择8个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。</td>
								<td>如：选择05 04 11 03 08 10 09 01，开奖号码为08 04 11 05 03，即为中奖。</td>
							</tr>
						</tbody>
					</table>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			activeName: "first",
		};
	},
};
</script>
<style>
.helpcenter_item1_title {
	height: 42px;
	border-bottom: 2px solid #0e78c7;
	line-height: 42px;
	padding: 0 20px;
	font-size: 16px;
}

.playIntro_box {
	padding: 19px;
	border-top: 0;
	border-bottom: 0;
	font-size: 12px;
}

.playIntro_box .el-tabs__item.is-active {
	color: #0e78c7;
}

.playIntro_box .el-tabs__active-bar {
	background-color: #0e78c7;
}

/* 表格样式 */
.table-bordered {
	border: 1px solid #ddd;
	margin-bottom: 20px;
	background: #fff;
	color: #606060;
}

h2 {
	width: 100%;
	background: #0e78c7;
	font-size: 14px;
	/* font-weight: 700; */
	font-weight: 400;
	color: #fff;
	line-height: 31px;
	margin: 1px 0 0;
	padding: 0;
	text-indent: 10px;
}

.table-bordered > tbody > tr > td,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > td,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
	vertical-align: middle;
	padding: 7px;
	text-align: center;
	border: 0;
	border-bottom: 1px solid #e0e0e0;
	border-right: 1px solid #e0e0e0;
}

.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
	padding: 8px;
	line-height: 1.42857143;
	border-top: 1px solid #ddd;
}

.table-bordered tbody tr:hover {
	background: rgb(245, 245, 245);
}

.table-striped > tbody > tr:nth-of-type(odd) {
	background-color: #f9f9f9;
}
</style>



// WEBPACK FOOTER //
// src/components/helpcenter/palyIntro.vue